module.exports = __webpack_public_path__ + "img/depmap_svg_V13.fa1cdbfc.svg";